export default {
  title: 'Start je abonnement',
  title_confirm: 'Bevestig je abonnement',
  step: 'Stap {{current}} van {{total}}',
  subtitle: '{{name}} · 1 locatie',
  trial_badge: '{{days}} dagen gratis',
  trial_headline: 'Eerste {{days}} dagen gratis',
  then_price: 'Daarna {{price}} / maand per locatie · incl. btw',
  price_per_month: '{{price}} / maand',
  price_terms: 'Per locatie, maandelijks gefactureerd · incl. btw',
  tier_upsell:
    'Schaal op naar {{threshold}}+ actieve locaties en het tarief voor al je locaties daalt automatisch naar {{price}} / maand per locatie.',
  tier_active: 'Volumetarief — {{threshold}}+ actieve locaties',
  due_today: 'Vandaag verschuldigd',
  from_date: 'Vanaf {{date}}',
  no_charge_today: 'Je wordt vandaag niet in rekening gebracht.',
  no_charge_until: 'Je wordt vandaag niet in rekening gebracht. Zeg uiterlijk op {{date}} op en je betaalt niets.',
  active: '{{plan}} is actief voor dit restaurant.',
  active_with_trial: '{{plan}} is actief voor dit restaurant, gratis tot {{date}}.',
  terms:
    'Ik ga akkoord met de <a href="{{terms_url}}" target="_blank" rel="noreferrer">FoodAmigos Partner Platform Voorwaarden</a>, inclusief activering, opzegging en terugbetalingen.',
  error: 'We konden de aankoop niet voltooien. Probeer het opnieuw.',
  loading: 'Abonnement van dit restaurant controleren…',
  load_error: 'We konden het abonnement van dit restaurant niet controleren.',
  unavailable: 'Dit product is niet beschikbaar voor dit restaurant. Neem contact op met je FoodAmigos accountmanager.',
  products: {
    online_ordering: {
      features: {
        ordering: {
          title: 'Online bestellen',
          description: 'Directe bestellingen op de eigen website van het restaurant',
        },
        reservations: {
          title: 'Tafelreserveringen',
          description: 'Gasten boeken direct online een tafel',
        },
        marketing: {
          title: 'Marketing Suite',
          description: 'Offer Builder, spaarprogramma en AI-antwoorden op Google-reviews',
        },
        pricing: {
          title: '0% commissie, geen opstartkosten',
          description: 'Eén licentie per locatie, maandelijks gefactureerd',
        },
      },
    },
    mobile_app: {
      features: {
        app: {
          title: 'De eigen app van het restaurant',
          description: 'In de App Store en Google Play',
        },
        engagement: {
          title: 'Pushmeldingen en loyaliteit',
          description: 'Laat gasten terugkomen met aanbiedingen en punten',
        },
        ordering: {
          title: 'Bestellen met 0% commissie',
          description: 'Directe bestellingen rechtstreeks vanuit de app',
        },
        apple: {
          title: 'Apple Developer-account vereist',
          description: '$99/jaar, betaald aan Apple, op naam van de rechtspersoon van het restaurant',
        },
      },
    },
    ai_website: {
      title: 'Website Builder-abonnement',
      subtitle_domain: 'Zet de website van {{name}} live op {{domain}}',
      features: {
        domain: {
          title: 'Je website, live op je eigen domein',
          description: 'De eigen website van het restaurant',
        },
        ai: {
          title: 'Gebouwd en bijgewerkt met AI',
          description: "Maak in enkele minuten pagina's, tekst en afbeeldingen voor het restaurant",
        },
        ordering: {
          title: 'Bestellen en reserveren ingebouwd',
          description: 'Gasten bestellen en boeken een tafel rechtstreeks vanaf de website',
        },
        pricing: {
          title: 'Geen opstartkosten',
          description: 'Eén licentie per locatie, maandelijks gefactureerd',
        },
      },
    },
    storefront: {
      title: 'Website Builder-abonnement',
      subtitle_domain: 'Zet de website van {{name}} live op {{domain}}',
      features: {
        domain: {
          title: 'Je website, live op je eigen domein',
          description: 'De eigen website van het restaurant',
        },
        ai: {
          title: 'Gebouwd en bijgewerkt met AI',
          description: "Maak in enkele minuten pagina's, tekst en afbeeldingen voor het restaurant",
        },
        ordering: {
          title: 'Bestellen en reserveren ingebouwd',
          description: 'Gasten bestellen en boeken een tafel rechtstreeks vanaf de website',
        },
        pricing: {
          title: 'Geen opstartkosten',
          description: 'Eén licentie per locatie, maandelijks gefactureerd',
        },
      },
    },
  },
  payment_method: {
    label: 'Je partnerbetaalmethode',
    on_file: 'Kaart op bestand',
    pending_title: 'Je betaalmethode wordt bevestigd',
    pending: 'Stripe bevestigt nog de kaart die je zojuist hebt toegevoegd. Dit kan even duren.',
    still_pending: 'Nog niet zover. Geef het even de tijd en controleer opnieuw.',
    error: 'We konden het betaalformulier niet openen. Probeer het opnieuw.',
  },
  buttons: {
    close: 'Sluiten',
    continue_to_payment: 'Verder naar betaling',
    start_trial: 'Start {{days}}-daagse gratis proefperiode',
    subscribe: 'Start abonnement',
    continue: 'Doorgaan',
    change: 'Wijzigen',
    retry: 'Opnieuw proberen',
    check_again: 'Opnieuw controleren',
    add_again: 'Voeg opnieuw een kaart toe',
  },
};
